import { render, staticRenderFns } from "./AuctionLotDetail.vue?vue&type=template&id=13ba4f0c&scoped=true&"
import script from "./AuctionLotDetail.vue?vue&type=script&lang=js&"
export * from "./AuctionLotDetail.vue?vue&type=script&lang=js&"
import style0 from "./AuctionLotDetail.vue?vue&type=style&index=0&id=13ba4f0c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13ba4f0c",
  null
  
)

export default component.exports